export default __webpack_public_path__ + "static/media/background.26d0fadc.jpg";